import * as CoreActions from './core.actions';
import * as CoreReducer from './core.reducer';

export {
    CoreActions,
    CoreReducer
};
